<template>
    <v-toolbar-items>
        <!--<v-btn flat class="hidden-sm-and-down">-->
        <!--<v-icon>grade</v-icon>&nbsp;Enter Awards-->
        <!--</v-btn>-->
        <!--<v-btn flat class="hidden-sm-and-down">-->
        <!--<v-icon>business</v-icon>&nbsp;MyGuild-->
        <!--</v-btn>-->
        <v-btn flat class="hidden-sm-and-down" v-if="isJudge" @click="openJudgingTab">
            <v-icon>insert_comment</v-icon>&nbsp;Judging
        </v-btn>
        <v-btn flat class="hidden-sm-and-down" v-if="isAdmin" @click="openAdminTab">
            <v-icon>settings</v-icon>&nbsp;Admin
        </v-btn>
        <v-menu
                v-model="menu"
                :close-on-content-click="false"
                offset-x
                :open-on-hover="true"
        >
            <v-btn slot="activator" :color="toolbarColour" depressed>
                <v-icon>account_circle</v-icon>
            </v-btn>

            <v-card>
                <v-list>
                    <v-list-tile avatar>
                        <v-list-tile-avatar>
                            <v-icon>face</v-icon>
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                            <v-list-tile-title>{{user.profile.displayName}}</v-list-tile-title>
                            <v-list-tile-sub-title>{{user.profile.email}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>

                <v-divider></v-divider>

                <!--TODO: have toggle for dark mode here-->
                <!--<v-list>-->
                <!--<v-list-tile>-->
                <!--<v-list-tile-action>-->
                <!--<v-switch v-model="message" color="purple"></v-switch>-->
                <!--</v-list-tile-action>-->
                <!--<v-list-tile-title>Enable messages</v-list-tile-title>-->
                <!--</v-list-tile>-->

                <!--<v-list-tile>-->
                <!--<v-list-tile-action>-->
                <!--<v-switch v-model="hints" color="purple"></v-switch>-->
                <!--</v-list-tile-action>-->
                <!--<v-list-tile-title>Enable hints</v-list-tile-title>-->
                <!--</v-list-tile>-->
                <!--</v-list>-->
                <v-card-text>
                    <v-btn @click="logoutRedirect" color="error" outline block>Logout</v-btn>
                </v-card-text>
            </v-card>
        </v-menu>
    </v-toolbar-items>
</template>

<script>
  export default {
    name: 'UserToolbarActions',
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      menu: false
    }),
    computed: {
      userRoles () {
        return this.user.permissions.roles
      },
      isAdmin () {
        return this.userRoles.admin
      },
      isJudge () {
        return this.userRoles.judge
      },
      toolbarColour () {
        if (this.systemConfig.hasOwnProperty('vuetify') && this.systemConfig.vuetify.hasOwnProperty('toolbarColour')) {
          return this.systemConfig.vuetify.toolbarColour
        }
        return null
      }
    },
    methods: {
      logoutRedirect () {
        this.menu = false
        this.$router.push({name: 'auth.logout'})
      },
      openJudgingTab () {
        window.open(this.systemConfig.clients.judging.appUrl, '_blank')
        // window.location.href = this.systemConfig.clients.judging.appUrl
      },
      openAdminTab () {
        window.open(this.systemConfig.clients.admin.appUrl, '_blank')
        // window.location.href = this.systemConfig.clients.admin.appUrl
      }
    }
  }
</script>

<style scoped>

</style>
